// extracted by mini-css-extract-plugin
module.exports = {"container":"FaqSection_container__seWKz"};